module.exports = __webpack_public_path__ + "img/profile-3.a6cdfa75.jpeg";